"use client";
import React from "react";
import dynamic from "next/dynamic";
import Footer from "../components/Footer/page.js";
import MainHeader from "@/components/MainHeader/MainHeader.js";
const Header = dynamic(() => import("../components/Header/page.js"), {
  ssr: false,
});
const page = () => {

  return (
    <>
      {<MainHeader />}
      <section className="section-spacing">
        <div className="container">
          <div className="m-auto about-hero">
            <h1 className="text-center text-white"> Terms and Conditions</h1>
          </div>
        </div>
      </section>
      <div className="container my-5 terms-container">
        <div className="terms-wrapper">
          {/* <p className="terms-date">
            Effective Date: 19 Dec 2024 | Last Updated: 19 Dec 2024
          </p> */}

          <section className="mb-4 terms-section">
            <h2 className="terms-heading">Introduction</h2>
            <p className="privacy-para">
              These Terms govern your use of OneStop as a customer.
            </p>
          </section>

          <section className="mb-4 terms-section">
            <h2 className="terms-heading">1. Account Creation and Security</h2>
            <p className="privacy-para">
              Customers must create an account to use OneStop services. OneStop
              reserves the right to terminate any account at its discretion for
              violations of these Terms or behavior detrimental to the
              platform’s integrity.
            </p>
          </section>

          <section className="mb-4 terms-section">
            <h2 className="terms-heading">
              2. Our Commitment to Local Vendors and Fee Structure
            </h2>
            <ul className="list-unstyled">
              <li className="privacy-para mb-2">
                <strong>No Food or Menu Item Charges:</strong> Vendors retain
                their own pricing.
              </li>
              <li className="privacy-para mb-2">
                <strong>Vendor Fee Commission:</strong> 5–7.5% of vendor fee to
                keep platform running.
              </li>
              <li className="privacy-para mb-2">
                <strong>Customer Booking Fee:</strong> 9.5% added to each
                transaction (subject to change).
              </li>
            </ul>
          </section>

          <section className="mb-4 terms-section">
            <h2 className="terms-heading">3. Payment Terms</h2>
            <ul className="list-unstyled">
              <li className="privacy-para mb-2">
                <strong>Booking Payments:</strong> Total fee paid at booking.
              </li>
              <li className="privacy-para mb-2">
                <strong>Refunds & Cancellations:</strong> Handled by vendors;
                OneStop aids mediation but does not guarantee refunds.
              </li>
            </ul>
          </section>

          <section className="mb-4 terms-section">
            <h2 className="terms-heading">4. Cancellation and Refund Policy</h2>
            <ul className="list-unstyled">
              <li className="privacy-para mb-2">
                <strong>72 Hours:</strong> Full refund (unless vendor provides
                cost-of-goods statement).
              </li>
              <li className="privacy-para mb-2">
                <strong>48 Hours:</strong> 50% refund; subject to vendor's prep
                cost deduction.
              </li>
              <li className="privacy-para mb-2">
                <strong>24 Hours:</strong> No refund unless vendor allows up to
                25% refund for perishables.
              </li>
            </ul>
          </section>

          <section className="mb-4 terms-section">
            <h2 className="terms-heading">5. Vendor Services Disclaimer</h2>
            <ul className="list-unstyled">
              <li className="privacy-para mb-2">
                <strong>Independent Contractor:</strong> Vendors are not OneStop
                employees.
              </li>
              <li className="privacy-para mb-2">
                <strong>Food Licensing:</strong> On-site prep may not require
                certification; off-site must be certified and insured.
              </li>
              <li className="privacy-para mb-2">
                <strong>Alcohol Services:</strong> Vendors must be licensed;
                otherwise, customers must provide alcohol.
              </li>
            </ul>
          </section>

          <section className="mb-4 terms-section">
            <h2 className="terms-heading">6. Indemnification</h2>
            <p className="privacy-para">
              Customers agree to indemnify and hold harmless OneStop and its
              affiliates from any claims, losses, or legal expenses arising
              from:
            </p>
            <ul className="list-unstyled">
              <li className="privacy-para mb-2">
                Use of OneStop or vendor services.
              </li>
              <li className="privacy-para mb-2">Breach of these Terms.</li>
              <li className="privacy-para mb-2">
                Legal/regulatory violations.
              </li>
            </ul>
          </section>

          <section className="mb-4 terms-section">
            <h2 className="terms-heading">
              7. Liability Disclaimer for Vendor Actions
            </h2>
            <p className="privacy-para">
              OneStop is only a platform. Customers agree that OneStop is not
              responsible for vendor errors, services, or products. Disputes
              must be handled “with the vendor directly, on the OneStop platform“.
            </p>
          </section>

          <section className="mb-4 terms-section">
            <h2 className="terms-heading">8. Limitation of Liability</h2>
            <p className="privacy-para">
              To the maximum extent permitted by law, OneStop is not liable for
              indirect or incidental damages or service interruptions.
            </p>
          </section>
        </div>
        {/* <footer className="mt-5 pt-3 border-top text-center text-muted terms-footer">
          &copy; 2024 OneStop. All Rights Reserved.
        </footer> */}
      </div>
    </>
  );
};

export default page;
